// Libraries
import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { DatePicker, Modal, Button } from 'antd'
import { Form, Formik } from 'formik'
import moment from 'moment'
// Api
import { epagAPI } from '../../../../API/epagAPI'
// Hooks
import { useGetToken } from '../../../../hooks/useGetToken'
import { useInputValue } from '../../../../hooks/useInputValue'
// Styles
import { TitleBoxBottomMargin, TitleBoxTopMargin } from '../styles'
import { EmptyDiv, ErrorText, InputFile } from '../../Inputs/styles'
import Select from '../../../Base/Forms/Select'
import { FullWidthButtonContainer, FormFieldWrapper } from '../../../Base/Forms/styles'
// Utils
import {
  disableFutureDates,
  setMessageWarning,
  sortSingleValuesList,
  updateSkillsByMode
} from '../../../../utils/utils'
// Components
import { AddNotFound } from '../../AddNotFound'
// Constants
import { Text } from '../../../../constants/TextConstants'
import { CERTIFICATIONS_SCHEMA, EDUCATIONAL_SCHEMA } from './schema'

export const ModalEducationalBackground = ({
  open,
  title,
  allowAdd = true,
  initialFormValues,
  fields,
  skillName,
  setModal,
  setModelProfile,
  mode,
  selectedTag
}) => {
  const { confirm } = Modal
  const formikRef = useRef()
  const [educationalData, setEducationalData] = useState(initialFormValues)
  const [disabledYear, setDisabledYear] = useState(true)
  const [isSavingNewSkill, setIsSavingNewSkill] = useState(false)
  const [searchValue, setSearchValue] = useState(null)
  const [schema, setSchema] = useState(null)
  const [skillList, setSkillList] = useState([])
  const { token } = useGetToken()
  const ErrorRequest = useInputValue(false)

  useEffect(() => {
    if (token !== null && open === true && skillList.length === 0) {
      epagAPI.GetSkills(skillName, token).then((response) => {
        if (response.length > 0) {
          const list = updateSkillsByMode(skillName, response[0], [])
          const sortedList = sortSingleValuesList(list)
          setSkillList(sortedList)
        }
      })
    }
    if (selectedTag) {
      if (mode === 'educational_background') {
        setEducationalData({
          institute: selectedTag.entity,
          grade: selectedTag.name,
          status: selectedTag.date !== Text.Currently ? Text.Finished.toLocaleLowerCase() : Text.NotFinished.toLocaleLowerCase(),
          end_date: selectedTag.date
        })
        setDisabledYear(selectedTag.status === Text.NotFinished.toLocaleLowerCase())
      } else {
        setEducationalData({
          certifying_entity: selectedTag.entity,
          name: selectedTag.name,
          status: selectedTag.date !== Text.Currently ? Text.Finished.toLocaleLowerCase() : Text.NotFinished.toLocaleLowerCase(),
          retriever_date: selectedTag.date
        })
        setDisabledYear(selectedTag.status === Text.NotFinished.toLocaleLowerCase())
      }
    }
  }, [open, token, skillList, selectedTag])

  useEffect(() => {
    let updatedSchema
    mode === 'educational_background'
      ? (updatedSchema = EDUCATIONAL_SCHEMA())
      : (updatedSchema = CERTIFICATIONS_SCHEMA())
    setSchema(updatedSchema)
  }, [educationalData])

  const onSubmit = (values) => {
    setModelProfile((prevState) => ({
      ...prevState,
      [mode]: selectedTag ? upatedQualificaton([...prevState[mode]]) : addQualification([...prevState[mode], values])
    }))
  }

  const addQualification = (values) => {
    let dateName
    mode === 'educational_background' ? (dateName = 'end_date') : (dateName = 'retriever_date')
    return values.sort((a, b) => {
      if (a[dateName] === Text.Currently && b[dateName] !== Text.Currently) {
        return -1
      }
      if (a[dateName] !== Text.Currently && b[dateName] === Text.Currently) {
        return 1
      }
      if (a[dateName] === Text.Currently && b[dateName] === Text.Currently) {
        return 0
      }
      return b[dateName] - a[dateName]
    })
  }

  const upatedQualificaton = (prevData) => {
    const qualificationUpdated = educationalData

    prevData[selectedTag.index] = qualificationUpdated
    return [...prevData]
  }

  const showAddConfirm = (event, setFieldValue, fieldName) => {
    event.stopPropagation()
    confirm({
      title: `${Text.AddAlertItemMessage}: ${searchValue}?`,
      centered: true,
      icon: '',
      okText: Text.Confirm,
      cancelText: Text.Cancel,
      onOk() {
        addNewItem(searchValue, setFieldValue, fieldName)
      },
      onCancel() {}
    })
  }

  const showDeleteConfirm = (event, item) => {
    event.stopPropagation()
    confirm({
      title: `${Text.DeleteAlertItemMessage}: ${item}?`,
      centered: true,
      icon: '',
      okText: Text.Confirm,
      cancelText: Text.Cancel,
      onOk() {
        deleteItem(item)
      },
      onCancel() {}
    })
  }

  const info = (value) => {
    Modal.info({
      title: `The value "${value}" was deleted`,
      icon: '',
      centered: true,
      onOk() {}
    })
  }

  const deleteItem = (item) => {
    epagAPI
      .DeleteSkill(skillName, item, token)
      .then((response) => {
        const list = updateSkillsByMode(skillName, response, [])
        const filteredList = list.filter((skillVal) => skillVal !== item)
        setSkillList(sortSingleValuesList(filteredList))
        info(item)
      })
      .catch((error) => {
        ErrorRequest.setErrorText(error.message)
        ErrorRequest.setError(true)
      })
  }

  const addNewItem = (value, setFieldValue, fieldName) => {
    if (value.trim() !== '') {
      setIsSavingNewSkill(true)
      epagAPI
        .CreateSkill(skillName, value, token)
        .then(() => {
          setSkillList([...skillList, value])
          setFieldValue(fieldName, value)
          setEducationalData({ ...educationalData, [fieldName]: value })
        })
        .catch((error) => {
          ErrorRequest.setErrorText(error.message)
          ErrorRequest.setError(true)
        })
        .finally(setIsSavingNewSkill(false))
    } else {
      setMessageWarning(Text.ErrorEmptyInput, Text.Degree)
    }
  }

  const onCancel = () => {
    setEducationalData(initialFormValues)
    formikRef?.current?.resetForm()
    setModal(false)
  }

  const setfieldData = (setFieldValue, fieldName, value) => {
    setEducationalData({ ...educationalData, [fieldName]: value })
    setFieldValue(fieldName, value)
  }

  const getOptionsFromArray = (array, tooltips = [], optionToBeFilter = []) =>
    array
      ? array
        .filter((item) => !optionToBeFilter.find((e) => e.skill_name === item))
        .map((item) => ({ value: item, label: item, tooltipText: tooltips[item] }))
      : []

  return (
    <Modal
      title={title}
      okText={!selectedTag ? Text.Add : Text.Update}
      open={open}
      maskClosable={false}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={null}
      keyboard={false}>
      <Formik
        initialValues={selectedTag ? educationalData : initialFormValues}
        enableReinitialize
        validationSchema={schema}
        onSubmit={(values, { resetForm }) => {
          onSubmit(values)
          resetForm()
          setEducationalData(initialFormValues)
          setModal(false)
        }}
        innerRef={formikRef}>
        {({ isValid, setFieldValue, resetForm, handleSubmit, errors, values }) => {
          return (
            <Form>
              <FormFieldWrapper>
                {fields.map((field, idx) => {
                  if (field.type === 'text') {
                    return (
                      <div key={idx} style={{ width: '100%' }}>
                        <TitleBoxTopMargin>{field.label}</TitleBoxTopMargin>
                        <InputFile
                          maxLength='150'
                          showCount
                          onChange={(evt) => {
                            setfieldData(setFieldValue, field.name, evt.target.value)
                          }}
                          value={educationalData[field.name]}
                        />
                        {errors[field.name] ? <ErrorText>{errors[field.name]}</ErrorText> : <EmptyDiv />}
                      </div>
                    )
                  }
                  if (field.type === 'autocomplete') {
                    return (
                      <div key={idx} style={{ width: '100%' }}>
                        <Select
                          name={field.name}
                          label={field.label}
                          showSearch
                          options={getOptionsFromArray(skillList)}
                          width='100%'
                          onChange={(value) => {
                            setfieldData(setFieldValue, field.name, value)
                          }}
                          showDeleteOption
                          onDeleteOption={showDeleteConfirm}
                          onSearch={(value) => setSearchValue(value)}
                          notFoundContent={
                            <AddNotFound
                              allowAdd={allowAdd}
                              isSaving={isSavingNewSkill}
                              addNewSkill={(e) => showAddConfirm(e, setFieldValue, field.name)}
                            />
                          }
                        />
                      </div>
                    )
                  }
                  if (field.type === 'select') {
                    return (
                      <div key={idx} style={{ width: 'calc(50% - 8px' }}>
                        <Select
                          name={field.name}
                          label={field.label}
                          options={field.options}
                          width='100%'
                          value={educationalData[field.name]}
                          onChange={(value) => {
                            setfieldData(setFieldValue, field.name, value)
                            value === 'finished' ? setDisabledYear(false) : setDisabledYear(true)
                          }}
                        />
                      </div>
                    )
                  }
                  if (field.type === 'date') {
                    return (
                      <div key={idx} style={{ width: 'calc(50% - 8px' }}>
                        <TitleBoxBottomMargin>{field.label}</TitleBoxBottomMargin>
                        <DatePicker
                          style={{
                            border: '1px solid #667080',
                            borderRadius: '6px',
                            padding: '7px 10px',
                            width: '100%'
                          }}
                          disabled={disabledYear}
                          disabledDate={disableFutureDates}
                          data-testid='start-date'
                          picker='year'
                          onChange={(_, dateString) => {
                            setfieldData(setFieldValue, field.name, dateString || 'In Progress')
                          }}
                          value={
                            educationalData[field.name] !== Text.Currently
                              ? moment(educationalData[field.name], 'YYYY')
                              : null
                          }
                        />
                        {!disabledYear && errors[field.name] ? (
                          <ErrorText>{errors[field.name]}</ErrorText>
                        ) : (
                          <EmptyDiv />
                        )}
                      </div>
                    )
                  }
                })}
                {!!ErrorRequest.ErrorValue && <ErrorText>{ErrorRequest.ErrorText}</ErrorText>}
                <FullWidthButtonContainer>
                  <Button onClick={onCancel} style={{ marginRight: '10px' }}>
                    Cancel
                  </Button>
                  <Button type='primary' onClick={() => handleSubmit()} disabled={!isValid} data-testid='save-button'>
                    Add
                  </Button>
                </FullWidthButtonContainer>
              </FormFieldWrapper>
            </Form>
          )
        }}
      </Formik>
    </Modal>
  )
}

ModalEducationalBackground.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  allowAdd: PropTypes.bool,
  initialFormValues: PropTypes.object,
  fields: PropTypes.array,
  skillName: PropTypes.string,
  setModal: PropTypes.func,
  setModelProfile: PropTypes.func,
  mode: PropTypes.string,
  selectedTag: PropTypes.object
}
